import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, TextField, Button, Paper } from '@material-ui/core';
import client from '../../utils/client';
import Alert from '../../utils/alert';
import errorToStr from '../../utils/errorToStr';

const useStyles = makeStyles((theme) => ({
    container: {
        padding: theme.spacing(2),
    },
    form: {
        display: 'flex',
        gap: theme.spacing(2),
        alignItems: 'center',
        flexWrap: 'wrap',
    },
    input: {
        minWidth: '300px',
        [theme.breakpoints.down('sm')]: {
            minWidth: '250px',
        },
    },
    button: {
        textTransform: 'none',
        fontSize: '1.4rem',
        padding: theme.spacing(1, 3),
        height: '56px', // Match TextField height
    },
}));

const ResendVerifyEmail = () => {
    const classes = useStyles();
    const [value, setValue] = useState('');

    const handleChange = e => {
        setValue(e.target.value);
    }

    const resendEmail = () => {
        let data = { email: value };

        client.post('admin/resendVerifyEmail', data)
            .then(res => {
                Alert.success("Sent!!");
            })
            .catch(error => {
                Alert.error(errorToStr(error));
            })
    }

    return (
        <Paper className={classes.container}>
            <Box component="form" className={classes.form}>
                <TextField
                    type="email"
                    name="email"
                    label="Email Address"
                    value={value}
                    onChange={handleChange}
                    variant="outlined"
                    className={classes.input}
                    placeholder="Enter email address"
                />
                <Button
                    type="button"
                    variant="contained"
                    color="primary"
                    onClick={resendEmail}
                    className={classes.button}
                >
                    Resend
                </Button>
            </Box>
        </Paper>
    )
}

export default ResendVerifyEmail;
